export default __webpack_public_path__ + "static/media/logo-desktop.c2756c31.svg";